import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  Grid,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Typography,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@mui/material/Slide";

import TopButton from "../../Components/UI/TopButtons";
import Placeholder from "../../Components/UI/Placeholder";

import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { getEvaluateAssetData } from "./Services";

const AssessAssetList = (props) => {
  //Hooks
  const styles = useStyles();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // Redux stateis
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { paramsdata } = useSelector((state) => state.common);

  // State
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    console.log("paramsdata", paramsdata);
    const getAssets = async () => {
      let assetData = await getEvaluateAssetData(
        paramsdata.assignmentId,
        userInfo.site_uuid
      );
      setAssets(assetData.data);
    };
    getAssets();
  }, [paramsdata]);

  // Route redirect function
  const goTo = (assetId, taskId, assignmentId, assetName) => {
    dispatch(
      commonSliceActions.setParamsData({
        assetId: assetId,
        taskId: taskId,
        assignmentId: assignmentId,
        assetName: assetName,
        assignmentName: paramsdata.assignmentName,
      })
    );
    navigation(`/Assess/LearnerList`);
  };

  return (
    <>
      <TopButton
        title={`Evaluate - (Assignment Name: ${paramsdata.assignmentName})`}
        secondaryText={`Asset List`}
        // isReportFilter={true}
        // handleFilter={handleFilterData}
      />

      <Grid
        container
        spacing={2}
        className={styles.scrollBar}
        sx={{
          px: 5,
          height: "75vh",
          overflow: "auto",
          justifyContent: "flex-start",
          alignContent: "flex-start",
        }}
      >
        {assets &&
          assets.length > 0 &&
          assets.map((assetData, index) => {
            return (
              <Slide
                direction="up"
                timeout={500}
                in={true}
                mountOnEnter
                unmountOnExit
              >
                <Grid item xs={6} sx={{ mt: 2 }} key={`${"asset_" + index}`}>
                  <List sx={{ margin: "0px !important" }}>
                    <ListItem
                      disablePadding
                      sx={{
                        borderRadius: 2,
                        padding: "0px",
                        backgroundColor: "#F5F7FF",
                      }}
                      onClick={() => {
                        goTo(
                          assetData.assetId,
                          assetData.taskId,
                          assetData.assignmetId,
                          assetData.assetName
                        );
                      }}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          au6ria-label="comments"
                          sx={{
                            color: "primary.main",
                            backgroundColor: "#FFFFFF",
                          }}
                        >
                          <NavigateNextIcon
                            sx={{
                              fontSize: "1.2rem",
                              "@media (min-width: 1636px)": {
                                fontSize: "2rem",
                              },
                            }}
                          />
                        </IconButton>
                      }
                    >
                      <ListItemButton sx={{ borderRadius: 5 }} dense>
                        <ListItemText sx={{ color: "primary.main" }}>
                          <Typography
                            sx={{
                              fontSize: "0.95rem",
                              fontWeight: "600",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            {assetData.assetName}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#A9A9A9",
                              fontSize: "0.7rem",
                              fontWeight: "600",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            {assetData.assetName}
                          </Typography>
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Grid>
              </Slide>
            );
          })}

        {!assets ||
          (assets.length == 0 && (
            <Placeholder
              primaryText="No assets"
              secondaryText="No assets available for evaluation"
              image="assign"
            ></Placeholder>
          ))}
      </Grid>
    </>
  );
};
const useStyles = makeStyles({
  activeText: {
    backgroundColor: "#d7e2f2",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default AssessAssetList;
